import * as i0 from '@angular/core';
import { inject, Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { EFFY_ENVIRONMENT } from '@effy-tech/angular-common/environment';
import { EffyLogoService, EffyLogoType } from '@effy-tech/angular-common/logo';
import { EffySite } from '@effy-tech/angular-common/site';
import { EFFY_WS_CONFIG } from '@effy-tech/angular-common/web-service';

var EffyIcons;
(function (EffyIcons) {
    // logo
    EffyIcons["EFFY_WHITE_LOGO"] = "effy-white-logo";
    EffyIcons["EFFY_ALT_LOGO"] = "effy-alt-logo";
    EffyIcons["EFFY_BASE_LOGO"] = "effy-base-logo";
    EffyIcons["EFFY_DEFAULT_LOGO"] = "effy-default-logo";
    EffyIcons["CALCULEO_WHITE_LOGO"] = "calculeo-white-logo";
    EffyIcons["CALCULEO_ALT_LOGO"] = "calculeo-alt-logo";
    EffyIcons["CALCULEO_BASE_LOGO"] = "calculeo-base-logo";
    EffyIcons["CALCULEO_DEFAULT_LOGO"] = "calculeo-default-logo";
    EffyIcons["LAPRIMEENERGIE_WHITE_LOGO"] = "laprimeenergie-white-logo";
    EffyIcons["LAPRIMEENERGIE_ALT_LOGO"] = "laprimeenergie-alt-logo";
    EffyIcons["LAPRIMEENERGIE_BASE_LOGO"] = "laprimeenergie-base-logo";
    EffyIcons["LAPRIMEENERGIE_DEFAULT_LOGO"] = "laprimeenergie-default-logo";
    EffyIcons["QUELLEENERGIE_WHITE_LOGO"] = "quelleenergie-white-logo";
    EffyIcons["QUELLEENERGIE_ALT_LOGO"] = "quelleenergie-alt-logo";
    EffyIcons["QUELLEENERGIE_BASE_LOGO"] = "quelleenergie-base-logo";
    EffyIcons["QUELLEENERGIE_DEFAULT_LOGO"] = "quelleenergie-default-logo";
    EffyIcons["PRO_WHITE_LOGO"] = "pro-white-logo";
    EffyIcons["PRO_ALT_LOGO"] = "pro-alt-logo";
    EffyIcons["PRO_BASE_LOGO"] = "pro-base-logo";
    EffyIcons["PRO_DEFAULT_LOGO"] = "pro-default-logo";
    EffyIcons["PRO_SERENITE_WHITE_LOGO"] = "pro-serenite-white-logo";
    EffyIcons["PRO_SERENITE_BASE_LOGO"] = "pro-serenite-base-logo";
    EffyIcons["PRO_SERENITE_DEFAULT_LOGO"] = "pro-serenite-default-logo";
    // other
    EffyIcons["ACCOUNT"] = "account";
    EffyIcons["ADD_BOX"] = "add-box";
    EffyIcons["ADD_LOCATION"] = "add-location";
    EffyIcons["ADD_CALENDAR"] = "add-calendar";
    EffyIcons["ASSIGNMENT_CHECK"] = "assignment-check";
    EffyIcons["ATTACHMENT"] = "attachment";
    EffyIcons["BANK"] = "bank";
    EffyIcons["BELL"] = "bell";
    EffyIcons["BOOK"] = "book";
    EffyIcons["BUILDING"] = "building";
    EffyIcons["CALCULATOR"] = "calculator";
    EffyIcons["CALENDAR"] = "calendar";
    EffyIcons["CAMERA"] = "camera";
    EffyIcons["CAMPAIGN"] = "campaign";
    EffyIcons["CAMPAIGNPRO"] = "campaignpro";
    EffyIcons["CERTIFIED"] = "certified";
    EffyIcons["CHAT_EMPTY"] = "chat-empty";
    EffyIcons["CHAT"] = "chat";
    EffyIcons["CHECK_CIRCLE"] = "check-circle";
    EffyIcons["CHECK_FILLED"] = "check-filled";
    EffyIcons["CHECK"] = "check";
    EffyIcons["CHEVRON_DOWN"] = "chevron-down";
    EffyIcons["CHEVRON_LEFT"] = "chevron-left";
    EffyIcons["CHEVRON_RIGHT"] = "chevron-right";
    EffyIcons["CHEVRON_UP"] = "chevron-up";
    EffyIcons["CLOCK"] = "clock";
    EffyIcons["CONSTRUCTION"] = "construction";
    EffyIcons["COPY"] = "copy";
    EffyIcons["CREDIT_CARD"] = "credit-card";
    EffyIcons["CREDIT_CARD_CLOCK"] = "credit-card-clock";
    EffyIcons["CROSS"] = "cross";
    EffyIcons["CROSS_CIRCLE"] = "cross-circle";
    EffyIcons["DOC_DOWNLOAD"] = "doc-download";
    EffyIcons["DOC_UPLOAD"] = "doc-upload";
    EffyIcons["DOC"] = "doc";
    EffyIcons["MY_DOC"] = "mes-doc";
    EffyIcons["DOUBLE_CHEVRON_RIGHT"] = "double-chevron-right";
    EffyIcons["DOWNLOAD"] = "download";
    EffyIcons["E_EFFY"] = "e-effy";
    EffyIcons["EDIT"] = "edit";
    EffyIcons["EDIT_CALENDAR"] = "edit-calendar";
    EffyIcons["EMPTY"] = "empty";
    EffyIcons["EURO"] = "euro";
    EffyIcons["EXTERNAL_LINK"] = "external-link";
    EffyIcons["EYE_OUTLINE"] = "eye-outline";
    EffyIcons["EYE_OUTLINE_OFF"] = "eye-outline-off";
    EffyIcons["FACEBOOK"] = "facebook";
    EffyIcons["FACTURE"] = "facture";
    EffyIcons["FAVORITE"] = "favorite";
    EffyIcons["FILE_EDIT"] = "file-edit";
    EffyIcons["FILES"] = "files";
    EffyIcons["FILTER"] = "filter";
    EffyIcons["GRAPH"] = "graph";
    EffyIcons["HANDSHAKE"] = "handshake";
    EffyIcons["HOME"] = "home";
    EffyIcons["HOURGLASS"] = "hourglass";
    EffyIcons["INFO"] = "info";
    EffyIcons["INSTAGRAM"] = "instagram";
    EffyIcons["LAPTOP"] = "laptop";
    EffyIcons["LINKEDIN"] = "linkedin";
    EffyIcons["LIGHTBULB"] = "lightbulb";
    EffyIcons["LIST"] = "list";
    EffyIcons["LOCATION_FILLED"] = "location-filled";
    EffyIcons["LOCATION_FORM"] = "location-form";
    EffyIcons["LOCATION_HOME"] = "location-home";
    EffyIcons["LOCATION"] = "location";
    EffyIcons["LOCK"] = "lock";
    EffyIcons["MAIL"] = "mail";
    EffyIcons["MAN"] = "man";
    EffyIcons["MENU"] = "menu";
    EffyIcons["MINUS"] = "minus";
    EffyIcons["MPR"] = "mpr";
    EffyIcons["PERSON"] = "person";
    EffyIcons["PHONE_OFF"] = "phone-off";
    EffyIcons["PHONE"] = "phone";
    EffyIcons["PHONEPLUS"] = "phoneplus";
    EffyIcons["PHOTO"] = "photo";
    EffyIcons["PLAY_YELLOW"] = "play-yellow";
    EffyIcons["PLUS"] = "plus";
    EffyIcons["POWER"] = "power";
    EffyIcons["REFRESH"] = "refresh";
    EffyIcons["ROCKET_LAUNCH"] = "rocket-launch";
    EffyIcons["SEARCH"] = "search";
    EffyIcons["SEND"] = "send";
    EffyIcons["SERVICE"] = "service";
    EffyIcons["SETTINGS"] = "settings";
    EffyIcons["SHIELD"] = "shield";
    EffyIcons["SHOP"] = "shop";
    EffyIcons["SMARTPHONE"] = "smartphone";
    EffyIcons["STAR_OUTLINED"] = "star-outlined";
    EffyIcons["STAR"] = "star";
    EffyIcons["SUITCASE"] = "suitcase";
    EffyIcons["TAB"] = "tab";
    EffyIcons["TIMER_FAST"] = "timer-fast";
    EffyIcons["TRASH"] = "trash";
    EffyIcons["TWITTER"] = "twitter";
    EffyIcons["UNLOCKED"] = "unlocked";
    EffyIcons["WALLET"] = "wallet";
    EffyIcons["WARNING"] = "warning";
    EffyIcons["YOUTUBE"] = "youtube";
    EffyIcons["ROOF"] = "roof";
    EffyIcons["WINDOW"] = "window";
    EffyIcons["HOT_WATER"] = "hot-water";
    EffyIcons["THERMOMETER"] = "thermometer";
    EffyIcons["FLOOR"] = "floor";
    EffyIcons["WALL"] = "wall";
    EffyIcons["BOOKMARK"] = "bookmark";
    EffyIcons["INFO_BUBBLE"] = "info-bubble";
    EffyIcons["LOGOUT"] = "logout";
    EffyIcons["OTP"] = "otp";
    EffyIcons["SHARE"] = "share";
    EffyIcons["ENERGY"] = "energy";
    EffyIcons["DASHBOARD"] = "dashboard";
    EffyIcons["ACCOUNT_SETTINGS"] = "account-settings";
    EffyIcons["CONTACT"] = "contact";
    EffyIcons["BUOY"] = "buoy";
    EffyIcons["ICAL"] = "ical";
    EffyIcons["GOOGLE_CALENDAR"] = "google-calendar";
    EffyIcons["OUTLOOK"] = "outlook";
})(EffyIcons || (EffyIcons = {}));
var EffyIconsWork;
(function (EffyIconsWork) {
    EffyIconsWork["AEROVOLTAIC"] = "aerovoltaic";
    EffyIconsWork["AIR_AIR_HEAT_PUMP"] = "air-air-heat-pump";
    EffyIconsWork["AIR_WATER_HEAT_PUMP"] = "air-water-heat-pump";
    EffyIconsWork["AIR_WATER_HEATPUMP_THERMODYNAMIC_HEATER"] = "air-Water-HeatPump-ThermodynamicHeater";
    EffyIconsWork["APPARTEMENT"] = "appartement";
    EffyIconsWork["ATTICS_INSULATION_CONVERTED"] = "attics-insulation-converted";
    EffyIconsWork["ATTICS_INSULATION_LOST"] = "attics-insulation-lost";
    EffyIconsWork["ATTICS_INSULATION"] = "attics-insulation";
    EffyIconsWork["AUDIT"] = "audit";
    EffyIconsWork["BASEMENT_INSULATION"] = "basement-insulation";
    EffyIconsWork["BOILER_TYPE_PELLET"] = "boiler-type-pellet";
    EffyIconsWork["BOILER_TYPE_WOOD"] = "boiler-type-wood";
    EffyIconsWork["CAVE"] = "cave";
    EffyIconsWork["COAL"] = "coal";
    EffyIconsWork["COMBINED_SOLAR_SYSTEM"] = "combined-solar-system";
    EffyIconsWork["CRAWL_SPACE"] = "crawl-space";
    EffyIconsWork["DOUBLE_GLAZING_ROLLER_BLINDS"] = "double-glazing-roller-blinds";
    EffyIconsWork["DOUBLE_GLAZING"] = "double-glazing";
    EffyIconsWork["DUAL_FLOW_CMV"] = "dual-flow-cmv";
    EffyIconsWork["ELECTRIC_BOILER"] = "electric-boiler";
    EffyIconsWork["ELECTRIC_HEATING"] = "electric-heating";
    EffyIconsWork["ELECTRIC_WATER_HEATER"] = "electric-water-heater";
    EffyIconsWork["ELECTRIC"] = "electric";
    EffyIconsWork["EXTERIOR_WALLS_INSULATION"] = "exterior-walls-insulation";
    EffyIconsWork["FIREPLACE_INSERT"] = "fireplace-insert";
    EffyIconsWork["FLOOR_INSULATION"] = "floor-insulation";
    EffyIconsWork["GARAGE_INSULATION"] = "garage-insulation";
    EffyIconsWork["GAS_CONDENSING_BOILER"] = "gas-condensing-boiler";
    EffyIconsWork["GAS_OTHER_BOILER"] = "gas-other-boiler";
    EffyIconsWork["GAS_STOVE"] = "gas-stove";
    EffyIconsWork["GAS"] = "gas";
    EffyIconsWork["GEOTHERMAL_HEAT_PUMP"] = "geothermal-heat-pump";
    EffyIconsWork["GLOBAL_RENOVATION"] = "global-renovation";
    EffyIconsWork["GPL"] = "gpl";
    EffyIconsWork["HABITABLE_ATTIC"] = "habitable-attic";
    EffyIconsWork["HEATPUMP"] = "heatpump";
    EffyIconsWork["HIGH_TEMPERATURE"] = "high-temperature";
    EffyIconsWork["HOUSE"] = "house";
    EffyIconsWork["HYBRID_HEAT_PUMP"] = "hybrid-heat-pump";
    EffyIconsWork["INTERIOR_WALLS_INSULATION"] = "interior-walls-insulation";
    EffyIconsWork["LOW_EFFICIENCY_ELECTRIC_HEATING"] = "low-efficiency-electric-heating";
    EffyIconsWork["LOW_TEMPERATURE"] = "low-temperature";
    EffyIconsWork["MEDIAN"] = "median";
    EffyIconsWork["MEDIUM_TEMPERATURE"] = "medium-temperature";
    EffyIconsWork["OIL_CONDENSING_BOILER"] = "oil-condensing-boiler";
    EffyIconsWork["OIL_OTHER_BOILER"] = "oil-other-boiler";
    EffyIconsWork["OIL_STOVE"] = "oil-stove";
    EffyIconsWork["OIL"] = "oil";
    EffyIconsWork["PHOTOVOLTAIC"] = "photovoltaic";
    EffyIconsWork["RADIATOR_WITH_GAS"] = "radiator-with-gas";
    EffyIconsWork["ROLLER_BLINDS"] = "roller-blinds";
    EffyIconsWork["ROOF_TERRACE"] = "roof-terrace";
    EffyIconsWork["ROOFTOP_INSULATION"] = "rooftop-insulation";
    EffyIconsWork["SOLAR_WATER_HEATER"] = "solar-water-heater";
    EffyIconsWork["STORAGE_HEATER"] = "storage-heater";
    EffyIconsWork["STOVE_TYPE_PELLET"] = "stove-type-pellet";
    EffyIconsWork["STOVE_TYPE_WOOD"] = "stove-type-wood";
    EffyIconsWork["THERMODYNAMIC_WATER_HEATER"] = "thermodynamic-water-heater";
    EffyIconsWork["UNHEATED_BASEMENT"] = "unheated-basement";
    EffyIconsWork["UNOCCUPIED_ATTICS"] = "unoccupied-attics";
    EffyIconsWork["WALLS_INSULATION"] = "walls-insulation";
    EffyIconsWork["WOOD_BOILER"] = "wood-boiler";
    EffyIconsWork["WOOD_STOVE"] = "wood-stove";
    EffyIconsWork["WOOD"] = "wood";
})(EffyIconsWork || (EffyIconsWork = {}));
const effyIconsMap = new Map([
    [
        '/images/pictos/other',
        [
            EffyIcons.ACCOUNT,
            EffyIcons.ADD_BOX,
            EffyIcons.ADD_LOCATION,
            EffyIcons.ADD_CALENDAR,
            EffyIcons.ASSIGNMENT_CHECK,
            EffyIcons.ATTACHMENT,
            EffyIcons.BELL,
            EffyIcons.BANK,
            EffyIcons.BOOK,
            EffyIcons.BUILDING,
            EffyIcons.BUOY,
            EffyIcons.CALCULATOR,
            EffyIcons.CALENDAR,
            EffyIcons.CAMERA,
            EffyIcons.CAMPAIGN,
            EffyIcons.CAMPAIGNPRO,
            EffyIcons.CERTIFIED,
            EffyIcons.CHAT_EMPTY,
            EffyIcons.CHAT,
            EffyIcons.CHECK_CIRCLE,
            EffyIcons.CHECK_FILLED,
            EffyIcons.CHECK,
            EffyIcons.CHEVRON_DOWN,
            EffyIcons.CHEVRON_LEFT,
            EffyIcons.CHEVRON_RIGHT,
            EffyIcons.CHEVRON_UP,
            EffyIcons.CLOCK,
            EffyIcons.CONSTRUCTION,
            EffyIcons.COPY,
            EffyIcons.CREDIT_CARD,
            EffyIcons.CREDIT_CARD_CLOCK,
            EffyIcons.CROSS,
            EffyIcons.CROSS_CIRCLE,
            EffyIcons.DOC_DOWNLOAD,
            EffyIcons.DOC_UPLOAD,
            EffyIcons.DOC,
            EffyIcons.MY_DOC,
            EffyIcons.DOUBLE_CHEVRON_RIGHT,
            EffyIcons.DOWNLOAD,
            EffyIcons.E_EFFY,
            EffyIcons.EDIT,
            EffyIcons.EDIT_CALENDAR,
            EffyIcons.EMPTY,
            EffyIcons.EURO,
            EffyIcons.EXTERNAL_LINK,
            EffyIcons.EYE_OUTLINE,
            EffyIcons.EYE_OUTLINE_OFF,
            EffyIcons.FACEBOOK,
            EffyIcons.FACTURE,
            EffyIcons.FAVORITE,
            EffyIcons.FILE_EDIT,
            EffyIcons.FILES,
            EffyIcons.FILTER,
            EffyIcons.GRAPH,
            EffyIcons.HANDSHAKE,
            EffyIcons.HOME,
            EffyIcons.HOURGLASS,
            EffyIcons.INFO,
            EffyIcons.INFO_BUBBLE,
            EffyIcons.INSTAGRAM,
            EffyIcons.LAPTOP,
            EffyIcons.LINKEDIN,
            EffyIcons.LIGHTBULB,
            EffyIcons.LIST,
            EffyIcons.LOCATION_FILLED,
            EffyIcons.LOCATION_FORM,
            EffyIcons.LOCATION_HOME,
            EffyIcons.LOCATION,
            EffyIcons.LOCK,
            EffyIcons.MAIL,
            EffyIcons.MAN,
            EffyIcons.MENU,
            EffyIcons.MINUS,
            EffyIcons.MPR,
            EffyIcons.PERSON,
            EffyIcons.PHONE_OFF,
            EffyIcons.PHONE,
            EffyIcons.PHONEPLUS,
            EffyIcons.PHOTO,
            EffyIcons.PLAY_YELLOW,
            EffyIcons.PLUS,
            EffyIcons.POWER,
            EffyIcons.REFRESH,
            EffyIcons.ROCKET_LAUNCH,
            EffyIcons.SEARCH,
            EffyIcons.SEND,
            EffyIcons.SERVICE,
            EffyIcons.SETTINGS,
            EffyIcons.SHIELD,
            EffyIcons.SHOP,
            EffyIcons.SMARTPHONE,
            EffyIcons.STAR_OUTLINED,
            EffyIcons.STAR,
            EffyIcons.SUITCASE,
            EffyIcons.TAB,
            EffyIcons.TIMER_FAST,
            EffyIcons.TRASH,
            EffyIcons.TWITTER,
            EffyIcons.UNLOCKED,
            EffyIcons.WALLET,
            EffyIcons.WARNING,
            EffyIcons.YOUTUBE,
            EffyIcons.ROOF,
            EffyIcons.LOGOUT,
            EffyIcons.DASHBOARD,
            EffyIcons.ENERGY,
            EffyIcons.ACCOUNT_SETTINGS,
            EffyIcons.CONTACT,
            EffyIcons.BOOKMARK,
            EffyIcons.WALL,
            EffyIcons.WINDOW,
            EffyIcons.FLOOR,
            EffyIcons.ENERGY,
            EffyIcons.HOT_WATER,
            EffyIcons.THERMOMETER,
            EffyIcons.SHARE,
            EffyIcons.ICAL,
            EffyIcons.GOOGLE_CALENDAR,
            EffyIcons.OUTLOOK,
        ],
    ],
    [
        '/images/pictos/works',
        [
            EffyIconsWork.AEROVOLTAIC,
            EffyIconsWork.AIR_AIR_HEAT_PUMP,
            EffyIconsWork.AIR_WATER_HEAT_PUMP,
            EffyIconsWork.AIR_WATER_HEATPUMP_THERMODYNAMIC_HEATER,
            EffyIconsWork.APPARTEMENT,
            EffyIconsWork.ATTICS_INSULATION_CONVERTED,
            EffyIconsWork.ATTICS_INSULATION_LOST,
            EffyIconsWork.ATTICS_INSULATION,
            EffyIconsWork.AUDIT,
            EffyIconsWork.BASEMENT_INSULATION,
            EffyIconsWork.BOILER_TYPE_PELLET,
            EffyIconsWork.BOILER_TYPE_WOOD,
            EffyIconsWork.CAVE,
            EffyIconsWork.COAL,
            EffyIconsWork.COMBINED_SOLAR_SYSTEM,
            EffyIconsWork.CRAWL_SPACE,
            EffyIconsWork.DOUBLE_GLAZING_ROLLER_BLINDS,
            EffyIconsWork.DOUBLE_GLAZING,
            EffyIconsWork.DUAL_FLOW_CMV,
            EffyIconsWork.ELECTRIC_BOILER,
            EffyIconsWork.ELECTRIC_HEATING,
            EffyIconsWork.ELECTRIC_WATER_HEATER,
            EffyIconsWork.ELECTRIC,
            EffyIconsWork.EXTERIOR_WALLS_INSULATION,
            EffyIconsWork.FIREPLACE_INSERT,
            EffyIconsWork.FLOOR_INSULATION,
            EffyIconsWork.GARAGE_INSULATION,
            EffyIconsWork.GAS_CONDENSING_BOILER,
            EffyIconsWork.GAS_OTHER_BOILER,
            EffyIconsWork.GAS_STOVE,
            EffyIconsWork.GAS,
            EffyIconsWork.GEOTHERMAL_HEAT_PUMP,
            EffyIconsWork.GLOBAL_RENOVATION,
            EffyIconsWork.GPL,
            EffyIconsWork.HABITABLE_ATTIC,
            EffyIconsWork.HEATPUMP,
            EffyIconsWork.HIGH_TEMPERATURE,
            EffyIconsWork.HOUSE,
            EffyIconsWork.HYBRID_HEAT_PUMP,
            EffyIconsWork.INTERIOR_WALLS_INSULATION,
            EffyIconsWork.LOW_EFFICIENCY_ELECTRIC_HEATING,
            EffyIconsWork.LOW_TEMPERATURE,
            EffyIconsWork.MEDIAN,
            EffyIconsWork.MEDIUM_TEMPERATURE,
            EffyIconsWork.OIL_CONDENSING_BOILER,
            EffyIconsWork.OIL_OTHER_BOILER,
            EffyIconsWork.OIL_STOVE,
            EffyIconsWork.OIL,
            EffyIconsWork.PHOTOVOLTAIC,
            EffyIconsWork.RADIATOR_WITH_GAS,
            EffyIconsWork.ROLLER_BLINDS,
            EffyIconsWork.ROOF_TERRACE,
            EffyIconsWork.ROOFTOP_INSULATION,
            EffyIconsWork.SOLAR_WATER_HEATER,
            EffyIconsWork.STORAGE_HEATER,
            EffyIconsWork.STOVE_TYPE_PELLET,
            EffyIconsWork.STOVE_TYPE_WOOD,
            EffyIconsWork.THERMODYNAMIC_WATER_HEATER,
            EffyIconsWork.UNHEATED_BASEMENT,
            EffyIconsWork.UNOCCUPIED_ATTICS,
            EffyIconsWork.WALLS_INSULATION,
            EffyIconsWork.WOOD_BOILER,
            EffyIconsWork.WOOD_STOVE,
            EffyIconsWork.WOOD,
        ],
    ],
]);

class EffyIconsService {
    constructor() {
        this.matIconRegistry = inject(MatIconRegistry);
        this.sanitizer = inject(DomSanitizer);
        this.effyLogoService = inject(EffyLogoService);
        this.env = inject(EFFY_ENVIRONMENT);
        this.commonAssetsApi = EFFY_WS_CONFIG.commonAssets[this.env];
    }
    init() {
        // Logos
        this.addLogoToRegistry(EffyIcons.EFFY_WHITE_LOGO, EffySite.EFFY, EffyLogoType.WHITE);
        this.addLogoToRegistry(EffyIcons.EFFY_ALT_LOGO, EffySite.EFFY, EffyLogoType.ALT);
        this.addLogoToRegistry(EffyIcons.EFFY_BASE_LOGO, EffySite.EFFY, EffyLogoType.BASE);
        this.addLogoToRegistry(EffyIcons.EFFY_DEFAULT_LOGO, EffySite.EFFY, EffyLogoType.DEFAULT);
        this.addLogoToRegistry(EffyIcons.CALCULEO_WHITE_LOGO, EffySite.CALCULEO, EffyLogoType.WHITE);
        this.addLogoToRegistry(EffyIcons.CALCULEO_ALT_LOGO, EffySite.CALCULEO, EffyLogoType.ALT);
        this.addLogoToRegistry(EffyIcons.CALCULEO_BASE_LOGO, EffySite.CALCULEO, EffyLogoType.BASE);
        this.addLogoToRegistry(EffyIcons.CALCULEO_DEFAULT_LOGO, EffySite.CALCULEO, EffyLogoType.DEFAULT);
        this.addLogoToRegistry(EffyIcons.LAPRIMEENERGIE_WHITE_LOGO, EffySite.LAPRIMEENERGIE, EffyLogoType.WHITE);
        this.addLogoToRegistry(EffyIcons.LAPRIMEENERGIE_ALT_LOGO, EffySite.LAPRIMEENERGIE, EffyLogoType.ALT);
        this.addLogoToRegistry(EffyIcons.LAPRIMEENERGIE_BASE_LOGO, EffySite.LAPRIMEENERGIE, EffyLogoType.BASE);
        this.addLogoToRegistry(EffyIcons.LAPRIMEENERGIE_DEFAULT_LOGO, EffySite.LAPRIMEENERGIE, EffyLogoType.DEFAULT);
        this.addLogoToRegistry(EffyIcons.QUELLEENERGIE_WHITE_LOGO, EffySite.QUELLEENERGIE, EffyLogoType.WHITE);
        this.addLogoToRegistry(EffyIcons.QUELLEENERGIE_ALT_LOGO, EffySite.QUELLEENERGIE, EffyLogoType.ALT);
        this.addLogoToRegistry(EffyIcons.QUELLEENERGIE_BASE_LOGO, EffySite.QUELLEENERGIE, EffyLogoType.BASE);
        this.addLogoToRegistry(EffyIcons.QUELLEENERGIE_DEFAULT_LOGO, EffySite.QUELLEENERGIE, EffyLogoType.DEFAULT);
        this.addLogoToRegistry(EffyIcons.PRO_WHITE_LOGO, EffySite.PRO, EffyLogoType.WHITE);
        this.addLogoToRegistry(EffyIcons.PRO_ALT_LOGO, EffySite.PRO, EffyLogoType.ALT);
        this.addLogoToRegistry(EffyIcons.PRO_BASE_LOGO, EffySite.PRO, EffyLogoType.BASE);
        this.addLogoToRegistry(EffyIcons.PRO_DEFAULT_LOGO, EffySite.PRO, EffyLogoType.DEFAULT);
        this.addLogoToRegistry(EffyIcons.PRO_WHITE_LOGO, EffySite.PRO, EffyLogoType.WHITE);
        this.addLogoToRegistry(EffyIcons.PRO_ALT_LOGO, EffySite.PRO, EffyLogoType.ALT);
        this.addLogoToRegistry(EffyIcons.PRO_BASE_LOGO, EffySite.PRO, EffyLogoType.BASE);
        this.addLogoToRegistry(EffyIcons.PRO_DEFAULT_LOGO, EffySite.PRO, EffyLogoType.DEFAULT);
        // Common assets
        effyIconsMap.forEach((icons, path) => icons.forEach(icon => this.matIconRegistry.addSvgIcon(icon, this.sanitizer.bypassSecurityTrustResourceUrl(`${this.commonAssetsApi}${path}/${icon}.svg`))));
    }
    addLogoToRegistry(icon, site, logoType) {
        this.matIconRegistry.addSvgIcon(icon, this.sanitizer.bypassSecurityTrustResourceUrl(this.effyLogoService.getUrl(site, logoType)));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.13", ngImport: i0, type: EffyIconsService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.13", ngImport: i0, type: EffyIconsService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.13", ngImport: i0, type: EffyIconsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class EffyIconsServiceMock {
    init() { }
}

/**
 * Generated bundle index. Do not edit.
 */

export { EffyIcons, EffyIconsService, EffyIconsServiceMock, EffyIconsWork };
